export default {
  format(shipmentAmount) {
    const statesMap = this.emptyMap();
    shipmentAmount.reduce((prev, { uf, amount, state_name, by_delivery_method }) => {
      statesMap[uf] = { amount, state_name, by_delivery_method };
      return statesMap;
    }, {});
    return statesMap;
  },

  emptyMap() {
    return {
      AC: {
        state_name: 'Acre',
        amount: 0,
        by_delivery_method: [],
      },
      AL: {
        state_name: 'Alagoas',
        amount: 0,
        by_delivery_method: [],
      },
      AP: {
        state_name: 'Amapá',
        amount: 0,
        by_delivery_method: [],
      },
      AM: {
        state_name: 'Amazonas',
        amount: 0,
        by_delivery_method: [],
      },
      BA: {
        state_name: 'Bahia',
        amount: 0,
        by_delivery_method: [],
      },
      CE: {
        state_name: 'Ceará',
        amount: 0,
        by_delivery_method: [],
      },
      DF: {
        state_name: 'Distrito Federal',
        amount: 0,
        by_delivery_method: [],
      },
      ES: {
        state_name: 'Espírito Santo',
        amount: 0,
        by_delivery_method: [],
      },
      GO: {
        state_name: 'Goiás',
        amount: 0,
        by_delivery_method: [],
      },
      MA: {
        state_name: 'Maranhão',
        amount: 0,
        by_delivery_method: [],
      },
      MT: {
        state_name: 'Mato Grosso',
        amount: 0,
        by_delivery_method: [],
      },
      MS: {
        state_name: 'Mato Grosso do Sul',
        amount: 0,
        by_delivery_method: [],
      },
      MG: {
        state_name: 'Minas Gerais',
        amount: 0,
        by_delivery_method: [],
      },
      PA: {
        state_name: 'Pará',
        amount: 0,
        by_delivery_method: [],
      },
      PB: {
        state_name: 'Paraíba',
        amount: 0,
        by_delivery_method: [],
      },
      PR: {
        state_name: 'Paraná',
        amount: 0,
        by_delivery_method: [],
      },
      PE: {
        state_name: 'Pernambuco',
        amount: 0,
        by_delivery_method: [],
      },
      PI: {
        state_name: 'Piauí',
        amount: 0,
        by_delivery_method: [],
      },
      RJ: {
        state_name: 'Rio de Janeiro',
        amount: 0,
        by_delivery_method: [],
      },
      RN: {
        state_name: 'Rio Grande do Norte',
        amount: 0,
        by_delivery_method: [],
      },
      RS: {
        state_name: 'Rio Grande do Sul',
        amount: 0,
        by_delivery_method: [],
      },
      RO: {
        state_name: 'Rondônia',
        amount: 0,
        by_delivery_method: [],
      },
      RR: {
        state_name: 'Roraima',
        amount: 0,
        by_delivery_method: [],
      },
      SC: {
        state_name: 'Santa Catarina',
        amount: 0,
        by_delivery_method: [],
      },
      SP: {
        state_name: 'São Paulo',
        amount: 0,
        by_delivery_method: [],
      },
      SE: {
        state_name: 'Sergipe',
        amount: 0,
        by_delivery_method: [],
      },
      TO: {
        state_name: 'Tocantins',
        amount: 0,
        by_delivery_method: [],
      },
      '': {
        state_name: 'Other',
        amount: 0,
        by_delivery_method: [],
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/features/private/dashboard/dashboards/sc-dashboard-map/store/formater.js